import React from "react"
import SbEditable from "storyblok-react"
import { blokType } from "../../types"

import { BookingsCmp, BookingsProps } from "./Bookings"

interface BookingsWrapperProps {
    blok: BookingsProps & blokType
}

const Bookings: React.FC<BookingsWrapperProps> = ({ blok }) => (
    <SbEditable content={blok}>
        <BookingsCmp
            image={blok.image}
            title={blok.title}
            copy={blok.copy}
            links={blok.links}
            icon_image={blok.icon_image}
            background={blok.background}
            text_color={blok.text_color}
        />
    </SbEditable>
)



export default Bookings
